"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
exports.useFull = (ref) => {
    ref = ref || react_1.default.useRef(null);
    const [showAsFullscreen, toggleFullscreen] = react_use_1.useToggle(false);
    const isFullscreen = react_use_1.useFullscreen(ref, showAsFullscreen, {
        onClose: () => toggleFullscreen(false),
    });
    return {
        isFullscreen,
        ref,
        showAsFullscreen,
        toggleFullscreen,
    };
};
//# sourceMappingURL=useFull.js.map